import type { ReactNode } from 'react';
import { Icono } from './Icono';
import './cifras.css';

/**
 * Tarjeta de cifra (componentes.md §21): título, la cifra grande (de la API, nunca contada ni calculada por el panel,
 * G121, G290), una línea debajo y, si lleva a algún sitio, «Ver …». La principal va en negro.
 */
export function TarjetaCifra({ titulo, cifra, moneda, pie, enlace, oscura = false, children }: { titulo: string; cifra: string; moneda?: string; pie?: ReactNode; enlace?: { texto: string; accion: () => void }; oscura?: boolean; children?: ReactNode }) {
    return (
        <section className={`rv-tcifra${oscura ? ' rv-tcifra--oscura' : ''}`} aria-label={titulo}>
            <div className="rv-tcifra__cab">
                <strong>{titulo}</strong>
                {enlace !== undefined && (
                    <button type="button" className="rv-tcifra__enlace" onClick={enlace.accion}>
                        <span>{enlace.texto}</span>
                        <Icono nombre="chevron-right" />
                    </button>
                )}
            </div>
            <div className="rv-tcifra__cifra">
                <span>{cifra}</span>
                {moneda !== undefined && <small>{moneda}</small>}
            </div>
            {pie !== undefined && <div className="rv-tcifra__pie">{pie}</div>}
            {children}
        </section>
    );
}
